module.exports = __webpack_public_path__ + "media/assets/images/gmail/banner_image-28c12933a1861ac9a5ffaa05f44d8d66.png";